import { useState, forwardRef } from "react";
import "./LodgeCard.css";
import { motion } from "framer-motion";
import RoomIcon from "@mui/icons-material/Room";
import Specs from "./../specs/Specs";
import HouseIcon from "@mui/icons-material/House";
import FavoriteIcon from "@mui/icons-material/Favorite";
import { useDispatch, useSelector } from "react-redux";
import {
  addLodge,
  deleteLodge,
  removeLodge,
  selectLikedLodges,
} from "../../features/slices/lodgeSlice";
import { toast } from "react-toastify";
import { selectUser } from "../../features/slices/userSlice";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { DELETE_URL } from "../../api/customEnpoints";

const LodgeCard = forwardRef(({ lodgeItem, type }, ref) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // const [liked, setLiked] = useState(false);
  const likedLodges = useSelector(selectLikedLodges);
  const activeUser = useSelector(selectUser);
  const token = activeUser?.token;
  const [isLiked, setIsLiked] = useState(() => {
    const getLikedLodge = likedLodges?.find((item) => item._id === lodgeItem._id);
    return !!getLikedLodge;
  });

  const handleFavorites = () => {
    if (isLiked) {
      dispatch(removeLodge(lodgeItem._id));
      setIsLiked((prev) => !prev);
    } else {
      dispatch(
        addLodge(lodgeItem)
      );
      setIsLiked((prev) => !prev);
    }
  };

  const numFormatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  });

  const handleShowMap = () => {
    toast.info("Map Coming Soon.. 😁");
  };

  const goToDetails = () => {
    navigate("/details", {
      state: {
        data: lodgeItem,
      },
    });
  };

  const handleDeleteLodge = (id, lodgename) => {
    dispatch(deleteLodge({ delete: true, id, name: lodgename, }))
    // try {
    //   const response = await axios.delete(`${DELETE_URL}/${id}`, {
    //     headers: { "x-auth-token": token },
    //     withCredentials: true,
    //   });
    //   dispatch(removeLodge(id));
    //   // console.log(response)
    //   toast.success(response?.data?.message);
    //   window.location.reload();
    // } catch (error) {
    //   toast.error(error?.response?.data?.msg);
    // }
  };

  const handleUpdateLodge = () => {
    navigate("/update-lodge", {
      state: {
        updateDetails: lodgeItem,
      },
    });
  };


  const getUser = useSelector(selectUser);

  const lodgeCardContent = (
    <>
      <div className="top">
        <img loading="lazy" src={lodgeItem.lodgepicture} alt="" />

        {isLiked ? (
          <>
            <motion.div
              onClick={handleFavorites}
              whileTap={{ scale: 0.8 }}
              className="like__box"
            >
              <FavoriteIcon className={`${"lodge-liked"}`} />
            </motion.div>
          </>
        ) : (
          <>
            <motion.div
              onClick={handleFavorites}
              whileTap={{ scale: 0.8 }}
              className="like__box"
            >
              <FavoriteIcon className={`${"lodge-like"}`} />
            </motion.div>
          </>
        )}
      </div>
      <div className="bottom">
        <div className="bottom-top">
          <div className="bottom__first">
            <p className="lodge__card-price">
              {lodgeItem.lodgeprice ? numFormatter.format(lodgeItem.lodgeprice).replace("$", "₦") : "₦ Price Unavailable"}
            </p>
            <motion.p onClick={handleShowMap} whileTap={{ scale: 0.8 }}>
              Show on map
            </motion.p>
          </div>
          <p className="lodge__name">{lodgeItem.lodgename}, FUTO</p>
          <p className="lodge__location">
            <RoomIcon className="desc__location-icon" />
            <span>{lodgeItem.address ? lodgeItem.address : "Location Unavailable"}</span>
          </p>

          <div className="featured__card-desc-fourth">
            {lodgeItem.specifications[0] ? lodgeItem.specifications[0]?.split(",").map((item, idx) => (<Specs key={idx} Icon={HouseIcon} text={item} />)) : <p className="no-specs">Specs Unavailable</p>}
          </div>
        </div>
        <div className="card-btns">
          <motion.div
            onClick={goToDetails}
            whileTap={{ scale: 0.8 }}
            className="featured__card-desc-btn"
          >
            View Details
          </motion.div>

          {getUser?.role === "admin" && (
            <>
              <motion.div
                onClick={handleUpdateLodge}
                whileTap={{ scale: 0.8 }}
                className="lodge-card-update-btn"
              >
                Update
              </motion.div>

              <motion.div
                whileTap={{ scale: 0.8 }}
                onClick={() => handleDeleteLodge(lodgeItem._id, lodgeItem.lodgename)}
                className="lodge-card-delete-btn"
              >
                Delete
              </motion.div>
            </>
          )}
        </div>
      </div>
    </>
  )

  return (
    <>
      {
        ref ?
          (
            <>
              <div ref={ref} className="lodge__card max-[450px]:w-full max-[330px]:w-[90vw]">
                {lodgeCardContent}
              </div>
            </>
          ) :
          (
            <>
              <div className="lodge__card max-[450px]:w-full max-[330px]:w-[90vw]">
                {lodgeCardContent}
              </div>
            </>
          )
      }
    </>
  );
});

export default LodgeCard;
